// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question[data-v-330be060]{margin-top:10px}.question[data-v-330be060]:first-child{margin-top:0}", ""]);
// Exports
module.exports = exports;
